/* Fade each main content section in once it enters the viewport. */
'use strict';
(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  const init = () => {
    const main = document.getElementById('main');
    if (!main) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.dataset.sectionReveal = 'visible';
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    const sections = main.querySelectorAll('section, .section, .section-tight, .page-head, .empty-state, .blog-content, .blog-grid > .blog-card');
    sections.forEach(section => {
      // A child of a pending section appears with its parent; visible wrappers
      // can still contain later sections that should reveal on their own.
      if (section.closest('[data-section-reveal="pending"]')) return;
      if (section.closest('[hidden]')) return;
      const content = section.querySelector(':scope > .container') || section;
      const bounds = content.getBoundingClientRect();
      if (!bounds.width || !bounds.height || bounds.top < innerHeight * 0.9) return;
      content.dataset.sectionReveal = 'pending';
      observer.observe(content);
    });

    const revealAll = () => {
      main.querySelectorAll('[data-section-reveal="pending"]').forEach(section => {
        section.dataset.sectionReveal = 'visible';
        observer.unobserve(section);
      });
    };
    reducedMotion.addEventListener('change', event => { if (event.matches) revealAll(); });
    main.addEventListener('focusin', event => {
      const section = event.target.closest('[data-section-reveal="pending"]');
      if (!section) return;
      section.dataset.sectionReveal = 'visible';
      observer.unobserve(section);
    });
    window.addEventListener('pageshow', event => { if (event.persisted) revealAll(); });
    // Editor previews must stay visible while Shopify replaces or selects sections.
    document.addEventListener('shopify:section:load', revealAll);
    document.addEventListener('shopify:section:select', revealAll);
    document.addEventListener('shopify:block:select', revealAll);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
